const csrfTokenElement = document.querySelector<HTMLMetaElement>(
  'meta[name="csrf-token"]'
)

export const csrfToken = csrfTokenElement?.content || ''
